import { useCallback, useState } from 'react';
import { NotificationManager } from 'components/react-notifications';
import { ENV } from 'config/env';

const BASE_URL = ENV.MESSAGE_API_URL;
const BASE_URL_V2 = ENV.MESSAGE_API_URL_V2;

const FetchHook = (baseUrl) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClient = useCallback(
    async (url, method, data = {}, options = {}) => {
      setLoading(true);
      setError(null);

      const requestData = { ...data, companyID: ENV.MSG_COMPANY_ID };

      let finalUrl = url;

      if (method === 'GET' || method === 'HEAD') {
        const query = new URLSearchParams(requestData).toString();
        finalUrl += (url.includes('?') ? '&' : '?') + query;
      }

      const { silent = false, ...requestOptions } = options;

      try {
        const { token, auth = true, headers: customHeaders, ...restOptions } = requestOptions;

        const authToken = token ?? localStorage.getItem('Pulsalink-message-token');

        const fetchOptions = {
          method,
          headers: {
            'Content-Type': 'application/json',

            ...(auth && authToken ? { Authorization: 'Bearer ' + authToken } : {}),
            ...customHeaders,
          },
          ...restOptions,
        };

        if (method !== 'GET' && method !== 'HEAD') {
          fetchOptions.body = JSON.stringify(requestData);
        }

        const response = await fetch(baseUrl + finalUrl, fetchOptions);

        const jsonResult = await response.json();

        if (!response.ok) {
          const responseMessage = jsonResult?.error || jsonResult?.message;
          const message =
            typeof responseMessage === 'string'
              ? responseMessage
              : responseMessage
                ? JSON.stringify(responseMessage)
                : `HTTP error! status: ${response.status}`;
          const error = new Error(message);
          error.status = response.status;
          error.data = jsonResult;
          error.retryAfter = Number(jsonResult?.retryAfter ?? response.headers.get('Retry-After'));
          throw error;
        }

        setLoading(false);
        return jsonResult;
      } catch (err) {
        setLoading(false);
        if (err.name === 'AbortError') {
          return;
        }
        if (err.status === 401) {
          if (!silent) {
            NotificationManager.error('Unauthorized access', 'Error', 3000);
          }
        } else if (err.status >= 500) {
          if (!silent) {
            NotificationManager.error('Server error. Please try again later.', 'Error', 3000);
          }
        } else if (err.status === 429) {
          if (!silent) {
            const retryAfter = Number(err.retryAfter);
            const retryMessage =
              Number.isFinite(retryAfter) && retryAfter > 0
                ? ` Coba lagi dalam ${Math.ceil(retryAfter / 60)} menit.`
                : '';
            NotificationManager.warning(
              `Terlalu banyak permintaan.${retryMessage}`,
              'Permintaan dibatasi',
              5000
            );
          }
        } else if (!silent) {
          NotificationManager.error(err.message || 'An unexpected error occurred.', 'Error', 3000);
        }
        setError(err);
        throw err;
      }
    },
    [baseUrl]
  );

  return { fetchClient, loading, error };
};

export const useFetchClient = () => FetchHook(BASE_URL);
export const useFetchChat = () => FetchHook(BASE_URL_V2);
